import mutations from "./mutations"
import getters from "./getters"
import { initialState } from "./state"

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations
}
